import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { MessageRow, MessageInputRow } from "namirasoft-message";
import { MessageRoutes } from "../src/MessageRoutes";
import { MessageRouterProps } from "./MessageRouterProps";
import { ProductUUID } from "namirasoft-api-product";
import { BaseColumnFormatter, DateTimeFormatter, IDFormatter, NSMenuActionProps, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { MessageMenus } from "./MessageMenus";
import { NamirasoftMap } from "namirasoft-site-map";
import { IStorageLocal } from "namirasoft-core";

export class MessageEntities
{
    static message(props: NSARouterMakerResult & MessageRouterProps, showMenus: boolean): IEntityInfo<MessageRow, MessageInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

        function getMenus(getIDs: () => string[])
        {
            let menus: NSMenuActionProps[] = [];
            if (showMenus)
            {
                menus.push(MessageMenus.MarkAllAsSeen(props));
                menus.push(MessageMenus.MarkAsSeen(props, getIDs));
            }
            return menus;
        }
        return {
            product_id: ProductUUID.NAMIRASOFT_MESSAGE,
            name: "message",
            tables: [{ table: namirasoft.message.tables.message, required: true }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.message.tables.message.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.message.tables.message.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.message.tables.message.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.message.tables.message.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.message.tables.message.columns.title, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.message.tables.message.columns.body, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.message.tables.message.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.message.tables.message.columns.seen_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => MessageRoutes.MessageList,
                getNewURL: null,
                getCopyURL: null,
                getEditURL: null,
                getViewURL: (id) => MessageRoutes.MessageView(id),
                getMenus: (getIDs) => { return { "Mark as seen": getMenus(getIDs) } },
            },
            server: {
                value_list: props.servers.message.value.List,
                get: props.servers.message.message.Get,
                list: props.servers.message.message.List,
                create: null,
                update: null,
                delete: null,
            }
        };
    }
}